export const CONDITION_COMPARE_TYPE = {
  GREATER: 'greater',
  LESS: 'less',
  EQUAL: 'equal',
  NOT_EQUAL: 'notEqual',
};

export const FILTER_TYPES = {
  DATE: 'date',
  SLIDER: 'slider',
  TEXT: 'text',
};

export const ACUITY_MAP = {
  mdn: 'MDN',
  stable: 'Stable',
};



// WEBPACK FOOTER //
// ./src/views/components/Common/Table/Constants/Constants.js